import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Department} from '../models/department';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  public contextCurrent:string;

  public departments: Department[] = []

  constructor (private db: AngularFirestore) { }

  select (context_id) {
    return this.db.collection<Department>('sbccv_departments', ref => ref
      .where("context_id", "==", context_id)
      .orderBy('short', 'asc')).snapshotChanges();
  }

  load (context_id) {
    return this.db.collection<Department>('sbccv_departments', ref => ref
      .where("context_id", "==", context_id)
      .orderBy('name', 'asc')).get();
  }

  getById (id) {
    return this.db.doc<Department>('sbccv_departments/' + id)
      .get();
  }

  insert (entity: Department) {
    return this.db.collection('sbccv_departments').add(Object.assign({}, entity));
  }

  update (entity: Department) {
    return this.db.collection('sbccv_departments').doc(entity.id).update(Object.assign({}, entity));
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_departments').doc(entity_id).delete();
  }

  
  loadDeptos (context_id) {
    
    this.load(context_id)
      .subscribe((result) => {
        this.departments = [];
        result.forEach((item) => {
          let entity = new Department();
          entity.id = item.id;
          entity.context_id = item.data().context_id;
          entity.name = item.data().name;
          entity.short = item.data().short;
          this.departments.push(entity);
        });
      })
  }
}
